import { ChangeEvent } from "react";
import Input from "Components/Input";
import Textarea from "Components/Textarea";

type Props = { payload: any; setPayload: any };

const ProductDetails = ({ payload, setPayload }: Props) => {
  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPayload({ ...payload, [name]: value });
  };

  return (
    <div>
      <Input
        label={"Purpose"}
        name={"purpose"}
        type={"text"}
        value={payload?.purpose}
        placeholder={"Purpose"}
        onChange={handleInputChange}
      />
      <Textarea
        label="Description"
        name={"description"}
        value={payload?.description}
        placeholder={""}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default ProductDetails;
